import { useScreenData } from './useScreenData';
import { SignalWeights, DEFAULT_SIGNAL_WEIGHTS } from '@/types/recommendation';

export { DEFAULT_SIGNAL_WEIGHTS };
export type { SignalWeights };

export function useSignalWeights(): SignalWeights {
  const { settings } = useScreenData('settings');
  const w = settings.aiSignalWeights;
  if (!w) return DEFAULT_SIGNAL_WEIGHTS;
  return {
    availability: w.availability ?? DEFAULT_SIGNAL_WEIGHTS.availability,
    utilisation: w.utilisation ?? DEFAULT_SIGNAL_WEIGHTS.utilisation,
    role: w.role ?? DEFAULT_SIGNAL_WEIGHTS.role,
    location: w.location ?? DEFAULT_SIGNAL_WEIGHTS.location,
    skills: w.skills ?? DEFAULT_SIGNAL_WEIGHTS.skills,
    budget: w.budget ?? DEFAULT_SIGNAL_WEIGHTS.budget,
  };
}

/** Returns the total of all weights — used to validate they sum to 100 */
export function signalWeightsTotal(w: SignalWeights): number {
  return w.availability + w.utilisation + w.role + w.location + w.skills + w.budget;
}
